import * as lockr from 'lockr';
import React, { createContext, useEffect, useReducer } from 'react';
import { getScore } from './Components/Results';
import { GUESS_COUNT } from './consts';
import { findDateDiff } from './helpers';
import { wordsRandomOrdered } from './wordsRandomOrdered';
export const AppContext = createContext();

export const DEFAULT_SCORE = { '0/2': 0, '1/2': 0, '2/2': 0 };

const initialState = lockr.get(findDateDiff()) || {
  input: [],
  guesses: [],
  wordOne: 'keder',
  wordOneDone: false,
  shake: false,
  wordTwo: 'araba',
};

export const ACTION_TYPES = {
  UPDATE_INPUT: 'UPDATE_INPUT',
  UPDATE_GUESSES: 'UPDATE_GUESSES',
  UPDATE_SHAKE: 'UPDATE_SHAKE',
  ADD_NEW_GUESS: 'ADD_NEW_GUESS',
  WORD_ONE_DONE: 'WORD_ONE_DONE',
  SET_WORDS: 'SET_WORDS',
};

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.UPDATE_INPUT:
      return {
        ...state,
        input: action.payload,
      };
    case ACTION_TYPES.UPDATE_GUESSES:
      return {
        ...state,
        guesses: action.payload,
      };
    case ACTION_TYPES.UPDATE_SHAKE:
      return {
        ...state,
        shake: action.payload,
      };
    case ACTION_TYPES.WORD_ONE_DONE:
      return {
        ...state,
        wordOneDone: true,
      };
    case ACTION_TYPES.SET_WORDS:
      return {
        ...state,
        ...action.payload,
      };
    case ACTION_TYPES.ADD_NEW_GUESS:
      const newGuesses = [...state.guesses, [...action.payload]];

      let wordOneDone = false;
      let wordTwoDone = false;

      newGuesses.forEach((guessAsArray) => {
        const guess = guessAsArray.join('');

        if (guess === state.wordOne) {
          wordOneDone = true;
        }
        if (guess === state.wordTwo) {
          wordTwoDone = true;
        }
      });

      const lastState = {
        ...state,
        guesses: [...state.guesses, [...action.payload]],
        input: [],
        wordOneDone,
        wordTwoDone,
      };

      if (lastState.guesses.length === GUESS_COUNT || (wordOneDone && wordTwoDone)) {
        const score = lockr.get('score') || DEFAULT_SCORE;
        const newScore = getScore({ guesses: lastState.guesses, words: [lastState.wordOne, lastState.wordTwo] });
        score[newScore] = score[newScore] + 1;
        lockr.set('score', score);
      }

      lockr.set(findDateDiff(), lastState);
      return lastState;

    default:
      throw new Error();
  }
};

export const AppContextProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  useEffect(() => {
    const diff = findDateDiff();
    const wordOne = diff * 2;

    dispatch({
      type: ACTION_TYPES.SET_WORDS,
      payload: { wordOne: wordsRandomOrdered[wordOne], wordTwo: wordsRandomOrdered[wordOne + 1] },
    });
  }, []);

  return <AppContext.Provider value={[state, dispatch]}>{props.children}</AppContext.Provider>;
};
